import { AxiosPromise } from 'axios';
import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';

export const getBankReportHistory = (personId: number, loanId: number, bankId: number): AxiosPromise<any> => {
    return AxiosClientFactory
        .getInstance()
        .get<any>(`/api/applicants/${personId}/consumerLoans/${loanId}/bankReportHistories/${bankId}`);
};
